export default __webpack_public_path__ + "static/privacy_and_secuity_feature-533b2272221743c7c45969f132789df5.png";